<template>
    <div style="position: relative;" class="rechargeBox" ref="container">

        <div  style="position: absolute;right: 20px;top: 20px;">
            <router-link class="record" :to="'/user/yueRecord'">
            <span style="color: #fff;">余额记录</span><span  style="color: #fff;" class="iconfont icon-xiangyou" ></span>
            </router-link>
        </div>

        <div class="payment-top acea-row row-column row-center-wrapper">
            <span class="name">代理余额</span>

            <div class="pic">
                ￥<span class="pic-font">{{ agent_now_money || 0 }}</span>
            </div>
            
        </div>
        <div class="recharge">
            <div class="nav acea-row row-around row-middle" style="margin-bottom: 10px;">
                <div class="item" :class="active === index ? 'on' : ''" v-for="(item, index) in navRecharge"
                    :key="index" @click="navRecharges(index)">
                    {{ item }}
                </div>
            </div>
            <div class="info-wrapper" >
                <div v-if="active">
                    <div class="list">
                        <div style="margin-bottom: 20px;" class="item acea-row row-between-wrapper" v-for="(item, index) in list" :key="index">
                            <div>
                               <div style="display: flex;">
                                 <div style="margin-right: 5px;" :style="item.paid == 1 ? 'color:green' : 'color:red'" class="state ">{{ item.paid_type }}</div>
                                 <div class="state">{{ item._recharge_type }}</div>
                               </div>
                                <div>{{ item._add_time }}</div>
                            </div>
                            <div style="text-align: right;">
                                <div class="num" >+{{ item.price }}</div>
                                <div class="num" v-if="Number(item.give_price) > 0">¥{{ item.give_price }}(赠送)</div>
                            </div>
                            
                            <!-- <div class="num font-color-red" v-if="item.pm == 0">
                                -{{ item.number }}
                            </div> -->
                        </div>
                    </div>


                    <div v-if="list.length ==0" style="text-align: center;margin: 10px 0 ;">
                        暂无记录
                    </div>
                </div>
                
                <div class="picList acea-row row-between mt-20" v-if="!active">
                    <div class="pic-box pic-box-color acea-row row-center-wrapper row-column"
                        :class="activePic == index ? 'pic-box-color-active' : ''" v-for="(item, index) in picList"
                        :key="index" @click="picCharge(index, item)">
                        <div class="pic-number-pic">
                            {{ item.price }}<span class="pic-number"> 元</span>
                        </div>
                        <div class="pic-number">赠送：{{ item.give_money }} 元</div>
                    </div>
                    <!-- <div class="pic-box pic-box-color acea-row row-center-wrapper"
                        :class="activePic == picList.length ? 'pic-box-color-active' : ''"
                        @click="picCharge(picList.length)">
                        <input type="number" placeholder="其他" v-model="money" class="pic-box-money pic-number-pic"
                            :class="activePic == picList.length ? 'pic-box-color-active' : ''" />
                    </div> -->
                </div>
                <div class="acea-row row-column" v-if="active == 0">
                    <div class="tip mt-30">注意事项：</div>
                    <div class="tip-samll" v-for="item in rechargeAttention" :key="item">
                        {{ item }}
                    </div>
                </div>
                <div class="pay-btn bg-color-red" v-if="active == 0" @click="recharge">
                    {{ active ? "立即转入" : "立即充值" }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { rechargeWechat, getRechargeApi, getRroxyRechargeType, RroxyRecharge, RroxyRechargeList,getUserInfo } from "@api/user";
import { add, sub } from "@utils/bc";
export default {
    name: "Recharge",
    props: {},
    data: function () {
        return {
            navRecharge: ["账户充值", "充值记录"],
            active: 0,
            payType: ["weixin"],
            from: isWeixin() ? "weixin" : "weixinh5",
            money: "",
            agent_now_money: "",
            picList: [],
            activePic: 0,
            numberPic: "",
            rechar_id: 0,
            rechargeAttention: [],
            loaded: false,
            loading: false,
             list: [],
            where: {
                page: 1,
                limit: 7
            },
        };
    },
    computed: mapGetters(["userInfo"]),
    mounted: function () {
        this.agent_now_money = this.userInfo.agent_now_money;
        this.getRecharge();

        this.getInfo();
        this.$scroll(this.$refs.container, () => {
           
            !this.loading && this.getInfo();
        });

        this.getUserInfoFun()
        
    },
    methods: {

         getUserInfoFun(){ //获取用户信息
            let that = this;
            getUserInfo().then(res => {
                that.agent_now_money = res.data.agent_now_money;
            })
        },
        getInfo: function () {
            let that = this;
            if (that.loaded == true || that.loading == true) return;
            that.loading = true;
            RroxyRechargeList(that.where).then(
                res => {
                    that.loading = false;
                    that.loaded = res.data.data.length < that.where.limit;
                    that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
                    that.where.page = that.where.page + 1;
                    that.list.push.apply(that.list, res.data.data);

                    console.log(res.data);
                    
                },
                err => {
                    that.$dialog.message(err.msg);
                }
            );
        },
        /**
         * 充值额度选择
         */
        getRecharge() {
            getRroxyRechargeType()
                .then(res => {
                    this.picList = res.data.recharge_quota;
                    if (this.picList[0]) {
                        this.rechar_id = this.picList[0].id;
                        this.numberPic = this.picList[0].price;
                    }
                    this.rechargeAttention = res.data.recharge_attention || [];
                })
                .catch(res => {
                    this.$dialog.toast({ mes: res });
                });
        },
        /**
         * 选择金额
         */
        picCharge(idx, item) {
            this.activePic = idx;
            if (item === undefined) {
                this.rechar_id = 0;
                this.numberPic = "";
            } else {
                this.money = "";
                this.rechar_id = item.id;
                this.numberPic = item.price;
            }
        },
        navRecharges: function (index) {
            this.active = index;
            this.rechar_id = this.picList[0].id;
            this.numberPic = this.picList[0].price;
            this.activePic = 0;
            this.money = ""; 



             
            // if(this.active == 1){
            //     this.getInfo();
            // }
        },
        recharge: function () {
            let that = this,
                price = Number(this.money);
            
                if (this.picList.length == this.activePic && price === 0) {
                    return that.$dialog.toast({ mes: "请输入您要充值的金额" });
                } else if (this.picList.length == this.activePic && price < 0.01) {
                    return that.$dialog.toast({ mes: "充值金额不能低于0.01" });
                }
                RroxyRecharge({
                    price: that.rechar_id == 0 ? that.money : Number(that.numberPic),
                    from: that.from,
                    rechar_id: that.rechar_id,
                    type: 0
                })
                    .then(res => {
                       
                        let data = res.data;
                        if (data.type == "weixinh5") {
                            location.replace(data.data.mweb_url);
                            this.$dialog.confirm({
                                mes: "充值余额",
                                opts: [
                                    {
                                        txt: "已充值",
                                        color: false,
                                        callback: () => {
                                            that.$router.replace({
                                                path: "/user/account"
                                            });
                                        }
                                    },
                                    {
                                        txt: "查看余额",
                                        color: false,
                                        callback: () => {
                                            that.$router.replace({
                                                path: "/user/account"
                                            });
                                        }
                                    }
                                ]
                            });
                        } else {
                            pay(data.data)
                                .finally(() => {
                                    // that.agent_now_money = add(
                                    //     price,
                                    //     parseInt(that.userInfo.agent_now_money)
                                    // );

                                     that.getUserInfoFun()
                                    that.$dialog.toast({ mes: "支付成功" });


                                })
                                .catch(function () {
                                    that.$dialog.toast({ mes: "支付失败" });
                                });
                        }
                    })
                    .catch(res => {
                       
                        
                        that.$dialog.toast({ mes: res.msg });
                    });
            
        }
    }
};
</script>
<style scoped>
.rechargeBox {
    height: 100%;
    background: #fff;
}

#iframe {
    display: none;
}

.pic-box-color-active {
    background-color: #9dccd0 !important;
    color: #fff !important;
}

.pic-box-active {
    width: 2.16rem;
    height: 1.2rem;
    background-color: #9dccd0;
    border-radius: 0.2rem;
}

.picList {
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
}

.font-color {
    color: #9dccd0;
}

.recharge {
    border-radius: 0.1rem;
    width: 100%;
    background-color: #fff;
    margin: 0.2rem auto 0 auto;
    padding: 0.3rem;
    border-top-right-radius: 0.39rem;
    border-top-left-radius: 0.39rem;
    margin-top: -0.45rem;
    box-sizing: border-box;
}

.recharge .nav {
    height: 0.75rem;
    line-height: 0.75rem;
    padding: 0 1rem;
}

.recharge .nav .item {
    font-size: 0.3rem;
    color: #333;
}

.recharge .nav .item.on {
    font-weight: bold;
    border-bottom: 0.04rem solid #9dccd0;
}

.recharge .info-wrapper .money {
    margin-top: 0.6rem;
    padding-bottom: 0.2rem;
    border-bottom: 1px dashed #ddd;
    text-align: center;
}

.recharge .info-wrapper .money span {
    font-size: 0.56rem;
    color: #333;
    font-weight: bold;
}

.recharge .info-wrapper .money input {
    display: inline-block;
    width: 3rem;
    font-size: 0.84rem;
    text-align: center;
    color: #282828;
    font-weight: bold;
    padding-right: 0.7rem;
}

.recharge .info-wrapper .money input::placeholder {
    color: #ddd;
}

.recharge .info-wrapper .money input::-webkit-input-placeholder {
    color: #ddd;
}

.recharge .info-wrapper .money input:-moz-placeholder {
    color: #ddd;
}

.recharge .info-wrapper .money input::-moz-placeholder {
    color: #ddd;
}

.recharge .info-wrapper .money input:-ms-input-placeholder {
    color: #ddd;
}

.tip {
    font-size: 0.28rem;
    color: #333333;
    font-weight: 800;
    margin-bottom: 0.14rem;
}

.tip-samll {
    font-size: 0.24rem;
    color: #333333;
    margin-bottom: 0.14rem;
}

.tip-box {
    margin-top: 0.3rem;
}

.recharge .info-wrapper .tips span {
    color: #9dccd0;
}

.recharge .info-wrapper .pay-btn {
    display: block;
    width: 100%;
    height: 0.86rem;
    margin: 0.5rem auto 0 auto;
    line-height: 0.86rem;
    text-align: center;
    color: #fff;
    border-radius: 0.5rem;
    font-size: 0.3rem;
    font-weight: bold;
}

.payment-top {
    width: 100%;
    height: 3.5rem;
    background-color: #9dccd0;
}

.payment-top .name {
    font-size: 0.26rem;
    color: rgba(255, 255, 255, 0.8);
    margin-top: -0.38rem;
    margin-bottom: 0.3rem;
}

.payment-top .pic {
    font-size: 0.32rem;
    color: #fff;
}

.payment-top .pic-font {
    font-size: 0.78rem;
    color: #fff;
}

.picList .pic-box {
    width: 32%;
    height: auto;
    border-radius: 0.2rem;
    margin-top: 0.21rem;
    padding: 0.2rem 0;
}

.pic-box-color {
    background-color: #f4f4f4;
    color: #656565;
}

.pic-number {
    font-size: 0.22rem;
}

.pic-number-pic {
    font-size: 0.38rem;
    margin-right: 0.1rem;
    text-align: center;
}

.pic-box-money {
    width: 100%;
    display: block;
}
</style>
